






























































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import Vuelidate from 'vuelidate';
import { required, minLength, between } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import vSelect from 'vue-select';

import { UsersApi, User, ProductsApi, Permission } from '../../../api';
import OrgPicker from '@/components/orgPicker.vue';
import ProductPicker from '@/components/product-picker.vue';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		OrgPicker,
		ProductPicker,
		secondaryNav,
		vSelect,
		Toast,
	},
	validations: {
		form: {
			//  org: {},
			product: {},
			permission: {},
		},
	},
	mixins: [validationMixin],
})
export default class RoleCreate extends Vue {
	public form = {
		org: {},
	};
	public errors = [];
	public user: any | null = null;
	public organisations: any = [];
	public $bvToast: any;
	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	public options = [
		{ value: 'product.admin', text: 'Product Administrator' },
		{ value: 'product.user', text: 'Product User' },
	];

	constructor() {
		super();
		this.api = new UsersApi();
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		const { userId } = this.$route.params;
		const permission: Permission = this.form;
		permission.productId = parseInt(this.form.product.id, 10);
		permission.permission = this.form.permission;
		permission.action = 'attach';

		if (
			this.form.product.type === 'fuel' ||
			this.form.product.type === 'water' ||
			(this.form.product.subscriptionitem.plan === 'trim' && this.form.product.users.length < 3) ||
			this.form.product.subscriptionitem.trialPlan === 'blueTop' ||
			this.form.product.subscriptionitem.trialPlan === 'fullCream' ||
			this.form.product.subscriptionitem.plan === 'blueTop' ||
			this.form.product.subscriptionitem.plan === 'fullCream'
		) {
			let response;
			try {
				response = await new UsersApi().userPermission(parseInt(userId, 10), { data: permission });
			} catch (e) {
				const error = e.response.data.errors.name[0];
				new Toast().makeToast(error, 'Error Adding User Permission', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}

			new Toast().makeToast('New Permission Allocated', 'Successfully Created', 'success');
			this.submitStatus = 'OK';

			setTimeout(() => {
				this.$router.push({ name: 'users.view', params: { userId: response.data.data.id } });
			}, 1000);
		} else {
			new Toast().makeToast(
				this.form.product.users.length +
					' Users on product. There is a maximum of 3 users on current ' +
					this.form.product.subscriptionitem.plan +
					' plan. Unable to add more users, upgrade plan.',
				'Not Created',
				'danger',
			);
			this.submitStatus = 'OK';
		}
	}

	public async load() {
		const { userId } = this.$route.params;
		this.loading = true;
		try {
			const response = await this.api.getUserId(parseInt(userId, 10), {
				params: { include: 'org,roles' },
			});
			const user: User = response.data;

			this.user = user;
		} catch (e) {
			console.log(e);
			this.user = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
